import { render } from "./PopupSyntheticObjectDelete.vue?vue&type=template&id=8ff7b114"
import script from "./PopupSyntheticObjectDelete.vue?vue&type=script&lang=js"
export * from "./PopupSyntheticObjectDelete.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__